import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import { GET_ADDRESS_BY_REFF, UPDATE_ADDRESS, UPDATE_CANDIDATE } from "../../API";
import LoadingBtn from "../../../../Widgets/LoadingBtn";
import { AlertNotif } from "../../../../../Library/AlertNotif";
import { Error404 } from "../../../../../Library/LoaderPage";
import {
  SelectCity,
  SelectCountry,
  SelectKecamatan,
  SelectProvince,
} from "../../_core/SelectInput";
import { openModal } from "../../../../../Library/ModalPopUp";
import { MessageError, MessageSuccess } from "../ProfileUI";
import { handleKeyDown } from "../../_core/_core";
import { EncodeURIComponentSafe } from "../../../../../Library/GlobalHelper";

export default function CardAddress({ student, ReloadDataStd, enrollment }) {
  const default_addr = {
    id: 0,
    reff_id: student?.reff_address_id || "",
    is_default: 1,
    address: "",
    city: "",
    city_id: 0,
    country: { code: "ID", id: 103, name: "Indonesia" },
    country_id: 103,
    postalcode: "",
    province: "",
    province_id: 0,
    kecamatan: "",
    kecamatan_id: 0,
    kelurahan: "",
  };
  const [address, setAddress] = useState({
    loading: false,
    data: default_addr,
    message: "",
  });
  const ReloadData = async () => {
    setAddress({ loading: true, data: [], message: "" });
    const results = await GET_ADDRESS_BY_REFF({
      reffid: student.reff_address_id,
    });
    if (results.data && Object.values(results.data).length > 0) {
      const main_addr = results.data.find(item => item.is_default === 1);
      if (main_addr && Object.values(main_addr).length > 0) {
        setAddress({ loading: false, data: main_addr, message: "" });
      } else {
        setAddress({ loading: false, data: results.data[0], message: "" });
      }
    } else {
      setAddress({ loading: false, data: default_addr, message: "" });
    }
  };

  useEffect(() => {
    if (student.reff_address_id) {
      ReloadData();
    }
  }, [student.reff_address_id]);

  return (
    <Card>
      <Card.Body>
        {address.loading ? (
          <LoadingBtn />
        ) : address.message ? (
          <AlertNotif message={address.message} color="danger" />
        ) : Object.values(address.data).length > 0 ? (
          <FormAddress data={address.data} ReloadDataStd={ReloadDataStd} enrollment={enrollment} />
        ) : (
          <Error404 />
        )}
      </Card.Body>
    </Card>
  );
}

const FormAddress = ({ data, ReloadDataStd, enrollment }) => {
  const has_enrollment = Object.values(enrollment).length > 0 ? true : false;
  const [errors, setErrors] = useState({});
  const [addr, setAddr] = useState(data?.address || "");
  const [country_id, setCountry_id] = useState(data?.country_id || 0);
  const [city_id, setCity_id] = useState(data?.city_id || 0);
  const [province_id, setProvince_id] = useState(data?.province_id || 0);
  const [kecamatan_id, setKecamatan_id] = useState(data?.kecamatan_id || 0);
  const [kelurahan, setKelurahan] = useState(data?.kelurahan || "");
  const [postalcode, setPostalcode] = useState(data?.postalcode || "");

  const validateForm = () => {
    let newErrors = {};

    if (!addr.trim()) newErrors.addr = "Address is required";
    if (!country_id) newErrors.country_id = "Country is required";
    if (!city_id) newErrors.city_id = "City is required";

    if (country_id === 103) {
      if (!province_id) newErrors.province_id = "Province is required";
      if (!kecamatan_id) newErrors.kecamatan_id = "Kecamatan is required";
      if (!postalcode) newErrors.postalcode = "Postalcode is required";

      if (!kelurahan.trim()) {
        newErrors.kelurahan = "Kelurahan is required";
      } else if (kelurahan.trim().length < 3) {
        newErrors.kelurahan = "Kelurahan must be at least 3 characters";
      } else if (/^\s|\s$/.test(kelurahan)) {
        newErrors.kelurahan = "Kelurahan cannot start or end with a space";
      }
    }

    setErrors(newErrors);
  };

  useEffect(() => {
    validateForm();
  }, [
    addr,
    country_id,
    city_id,
    province_id,
    kecamatan_id,
    kelurahan,
    postalcode,
  ]);

  const [submit, setSubmit] = useState({
    loading: false,
    data: [],
    message: "",
  });
  const SubmitHandler = async (e) => {
    e.preventDefault();
    if (Object.keys(errors).length === 0) {
      setSubmit({ loading: true, message: "", data: [] });
      const param = {
        id: data.id,
        reff_id: data.reff_id,
        is_default: 1,
        address: EncodeURIComponentSafe(addr),
        city_id,
        country_id,
        postalcode,
        province_id,
        kecamatan_id,
        kelurahan: EncodeURIComponentSafe(kelurahan),
      };
      console.log(param);
      console.log("Form is valid, submitting...");

      let is_finish = false;
      if (has_enrollment) {
        const param_enrollment = {
          id: enrollment?.regstudent?.id,
          address: param.address,
          country_id: param.country_id,
          city_id: param.city_id,
          postalcode: param.postalcode
        }
        try {
          const update_data = await UPDATE_CANDIDATE(param_enrollment);
          console.log(update_data);
        } catch (error) {
          console.log(error);
        }
        is_finish = true;
      } else {
        is_finish = true;
      }

      if (is_finish) {
        try {
          const results = await UPDATE_ADDRESS(param);
          if (results.data && Object.values(results.data).length > 0) {
            openModal({
              message: <MessageSuccess message={"Successfully saved"} />,
            });
            ReloadDataStd();
          } else {
            openModal({
              message: (
                <MessageError message={results.message} title="Failed Save" />
              ),
            });
          }
          setSubmit(results);
        } catch (error) {
          setSubmit({ loading: false, message: error?.message, data: [] });
          openModal({
            message: (
              <MessageError message={error?.message} />
            ),
          });
        }
      } else {
        setSubmit({ loading: false, message: "No data post founded", data: [] });
        openModal({
          message: (
            <MessageError
              message={
                "No data post founded."
              }
            />
          ),
        });
      }
    } else {
      openModal({
        message: (
          <MessageError
            message={
              "Please verify your input and ensure it is completed correctly."
            }
          />
        ),
      });
      setSubmit({ loading: false, message: "", data: [] });
    }
  };

  const disabled_field = data.reff_id ? false : true;
  return (
    <form method="post" autoComplete="off" onSubmit={(e) => SubmitHandler(e)}>
      {!data.reff_id && (
        <AlertNotif title={"Update not allowed"} message={"Unable to update the data because the reference ID (reff_id) is not associated with this student."} color="danger" />
      )}
      <div className="row mb-8">
        <label className="col-lg-4 col-form-label required font-weight-semibold h6">
          Address <sup className="text-danger">*</sup>
        </label>
        <div className="col-lg-8">
          <textarea
            name="address"
            className="form-control form-control-lg form-control-solid"
            defaultValue={addr}
            onChange={(e) => setAddr(e.target.value)}
            disabled={disabled_field}
          ></textarea>
          {errors.addr && <div className="text-danger">{errors.addr}</div>}
        </div>
      </div>

      <div className="row mb-8">
        <label className="col-lg-4 col-form-label required font-weight-semibold h6">
          Country <sup className="text-danger">*</sup>
        </label>
        <div className="col-lg-4">
          <SelectCountry
            data={country_id}
            setData={setCountry_id}
            isSolid={true}
            disabled={disabled_field}
          />
          {errors.country_id && (
            <div className="text-danger">{errors.country_id}</div>
          )}
        </div>
      </div>

      <div className="row mb-8">
        <label className="col-lg-4 col-form-label required font-weight-semibold h6">
          Province <sup className="text-danger">*</sup>
        </label>
        <div className="col-lg-4">
          <SelectProvince
            data={province_id}
            setData={setProvince_id}
            isSolid={true}
            disabled={disabled_field}
          />
          {errors.province_id && (
            <div className="text-danger">{errors.province_id}</div>
          )}
        </div>
      </div>

      <div className="row mb-8">
        <label className="col-lg-4 col-form-label required font-weight-semibold h6">
          City <sup className="text-danger">*</sup>
        </label>
        <div className="col-lg-4">
          <SelectCity data={city_id} setData={setCity_id} isSolid={true} disabled={disabled_field} />
          {errors.city_id && (
            <div className="text-danger">{errors.city_id}</div>
          )}
        </div>
      </div>

      <div className="row mb-8">
        <label className="col-lg-4 col-form-label required font-weight-semibold h6">
          Kecamatan <sup className="text-danger">*</sup>
        </label>
        <div className="col-lg-4">
          <SelectKecamatan
            data={kecamatan_id}
            setData={setKecamatan_id}
            isSolid={true}
            city_id={city_id}
            disabled={disabled_field}
          />
          {errors.kecamatan_id && (
            <div className="text-danger">{errors.kecamatan_id}</div>
          )}
        </div>
      </div>

      <div className="row mb-8">
        <label className="col-lg-4 col-form-label required font-weight-semibold h6">
          Kelurahan <sup className="text-danger">*</sup>
        </label>
        <div className="col-lg-4">
          <input
            type="text"
            className="form-control form-control-lg form-control-solid"
            value={kelurahan}
            disabled={disabled_field}
            onChange={(e) => {
              const inputValue = e.target.value;
              const regex = /^\s|\s{2,}|^\s+$/;
              if (!regex.test(inputValue)) {
                setKelurahan(inputValue);
              }
            }}
          />
          {errors.kelurahan && (
            <div className="text-danger">{errors.kelurahan}</div>
          )}
        </div>
      </div>

      <div className="row mb-8">
        <label className="col-lg-4 col-form-label required font-weight-semibold h6">
          Postal Code <sup className="text-danger">*</sup>
        </label>
        <div className="col-lg-4">
          <input
            type="text"
            name="postalcode"
            className="form-control form-control-lg form-control-solid mb-3 mb-lg-0"
            onKeyDown={handleKeyDown}
            disabled={disabled_field}
            onInput={(e) => {
              const value = e.target.value.replace(/\D/g, "");
              setPostalcode(value);
            }}
            value={postalcode}
          />
          {errors.postalcode && (
            <div className="text-danger">{errors.postalcode}</div>
          )}
        </div>
      </div>

      <div className="text-right mt-8">
        <button
          className="btn btn-lg btn-primary mr-3"
          type="submit"
          disabled={submit.loading}
        >
          {submit.loading ? "Processing..." : "Save Changes"}
        </button>
      </div>
    </form>
  );
};
